import { render } from "./PlaceSettings.vue?vue&type=template&id=493d7077&scoped=true"
import script from "./PlaceSettings.vue?vue&type=script&lang=ts"
export * from "./PlaceSettings.vue?vue&type=script&lang=ts"

import "./PlaceSettings.vue?vue&type=style&index=0&id=493d7077&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-493d7077"

export default script